// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z_zrq","col":"styles_col__3H0IT","actions":"styles_actions__36-r1","conflict":"styles_conflict__1uXXO"};